//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  ALTERNATE_TOASTS,
  LegacyToastTemplateType,
  TOAST_NOTIFICATIONS_ACTIONS,
} from '@legacy-components/common/toast-notifications/toastNotificationsConstants';

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export interface IToastNotifications {
  toastNotifications: IToastNotificationWithId[];
  toastNotificationsToClose: string[];
}

export interface IToastNotification {
  /**
   * An optional parameter that, when set, assigns a custom ID for the toast notification.
   * This ID can later be used to remove the notification from the screen.
   */
  id?: string;
  title: string;
  type?: ToastType;
  message?: string;
  options?: {
    toastTemplate?: ALTERNATE_TOASTS | LegacyToastTemplateType;
    onHidden?: (wasClosedViaClick: boolean, toast: IToastNotification) => void;
    extraData?: {
      linkText?: string;
      callback?: () => void;
      className?: string;
    };
    // Set `extendedTimeOut` and `timeOut` to 0 for sticky toast
    extendedTimeOut?: number; // Time to close after a user hovers over toast
    timeOut?: number; // Time to live in milliseconds

    // Options specific to the LEGACY_TOASTS used in the content drawer
    allowHtml?: boolean;
    customIconClass?: string;
    hideProgress?: boolean;
    positionClass?: string;
  };
}

export interface IPlainToast extends Pick<IToastNotification, 'title'> {
  options: {
    toastTemplate: ALTERNATE_TOASTS.PLAIN_TOAST;
  };
}

export interface IToastNotificationWithId extends IToastNotification {
  id: string;
}

export interface IToastAddNotificationAction {
  type: TOAST_NOTIFICATIONS_ACTIONS.ADD_TOAST_NOTIFICATION;
  toastNotification: IToastNotification;
}
